// extracted by mini-css-extract-plugin
export default {"body":"GXGoOmb_","mobile":"mobile","email":"TLLJfakH","emailChange":"givA6SyL"};